import GroupOutlinedIcon from '@mui/icons-material/GroupOutlined'
import { PERSONA_STATUS_KEYS } from '../../helpers/personas/personaStatusLabels'
import useStatusDisplays from '../../hooks/useStatusDisplay'
import { ALL_PERSONA_STATUSES } from '../../helpers/personas/filterPersonasByStatus'

// De kaart toont standaard alleen actieve deelnemers. Wie een jaar wil
// verantwoorden heeft ook de mensen nodig die inmiddels zijn uitgestroomd —
// die hebben dat jaar gewoon meegedraaid. Vandaar dit filter naast het
// locatiefilter, in dezelfde chipvorm.

/**
 * @param {object} props
 * @param {string} props.selectedStatus - '' (alleen actief), 'all', of één
 *   status uit `PERSONA_STATUS_KEYS`
 * @param {(status: string) => void} props.onChange - Krijgt de nieuwe keuze
 * @returns {JSX.Element}
 */
const DashboardPersonaStatusFilter = ({ selectedStatus, onChange }) => {
    // Alleen de LABELS volgen de instelling, niet de zichtbaarheid: dit is een
    // analysefilter zonder tegenhanger. Zou een verborgen status hier
    // wegvallen, dan zijn de deelnemers die hem nog dragen nergens meer te
    // selecteren — en anders dan bij de tabs op de deelnemerslijst is er hier
    // geen telling waarmee we 'nog bezet' kunnen zien.
    const labels = useStatusDisplays().persona.labels

    return (
        <label className="dashboard-filter-chip">
            <GroupOutlinedIcon fontSize="small" className="dashboard-filter-chip-icon" />
            <span className="dashboard-filter-chip-label">Deelnemers:</span>
            <select
                className="dashboard-filter-chip-select"
                value={selectedStatus || ''}
                onChange={(e) => onChange(e.target.value)}
            >
                <option value="">Alleen actief</option>
                <option value={ALL_PERSONA_STATUSES}>Alle, ook niet meer actief</option>
                {/* 'active' zit al in de eerste optie. Zou hij hier nog een keer
                    staan, dan tonen twee regels hetzelfde met een andere waarde —
                    en de tweede laat de kaart een filter melden terwijl je naar de
                    standaardweergave kijkt. */}
                {PERSONA_STATUS_KEYS
                    .filter((key) => key !== 'active')
                    .map((key) => (
                        <option key={key} value={key}>
                            Alleen {labels[key].toLowerCase()}
                        </option>
                    ))}
            </select>
        </label>
    )
}

export default DashboardPersonaStatusFilter
